import React, { useState, useEffect } from 'react'
import { Modal, Button, Input, message } from 'antd';
import { useSaleSoModel } from "../saleSoModel";
import { YhOfferPrint } from "@/components/YhPrint/OfferPrint/OfferPrint"
import { saleSoService } from '../saleSoService';
import { IDetailList, ISaleSoDetail } from '../saleSoTypes';
import { formatNum, fmoney } from '@/utils/utils';
import { useDictModel } from '@/views/base/dict/dictModel';

export type IMaintenanceAndItemType = {
    total: number
    discount: number
}
export type TotalType = {
    num: number,
    total: number
}
export function OfferPrint() {
    const initDesc = { total: 0, discount: 0 }
    const totalDesc = { total: 0, num: 0 }
    const {
        offerPrint: visible,
        selectedRow,
        setOfferPrint,
        onPrinting,
    } = useSaleSoModel();
    const [formVal, setFormVal] = useState<ISaleSoDetail>();
    const [maintenanceList, setMaintenanceList] = useState<IDetailList[]>([]);
    // const [itemList, setItemList] = useState<IItemDetailList[]>([]);
    const [maintenanceTotal, setMaintenanceTotal] = useState<IMaintenanceAndItemType>(initDesc);
    const [itemTotal, setItemTotal] = useState<IMaintenanceAndItemType>(initDesc);
    const [total, setTotal] = useState<TotalType>(totalDesc);
    const { getTreeNodeName } = useDictModel();

    useEffect(() => {
        visible && getPoDetailOne()
    }, [visible])
    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await saleSoService.one(selectedRow.saleCode as string);
        let { details, ...formVal } = retData;
        let newMaintenanceTotal = { ...maintenanceTotal }
        let newItemTotal = { ...itemTotal }
        let newTotal = { ...total }


        let newdetails: any = details?.map((item, index) => {
            newMaintenanceTotal.total += Number(item.num) * Number(item.price)
            newMaintenanceTotal.discount = item.discountRate as number
            newTotal.num += Number(item.num)
            let { price, amount, discountRate } = item

            return {
                ...item,
                No: index + 1,
                notAmount: Number(item.num) * Number(item.price),
                taxPrice: fmoney(formatNum(Number(price) * Number(discountRate) / 100), 2),
                amount: fmoney(amount, 2)

            }
        })
        newdetails?.push({
            num: newTotal.num,
            No: "",
            materialCode: "合计",
            amount: fmoney(formVal.totalAmount, 2)
        })
        if (retData) {
            setMaintenanceList(newdetails as ISaleSoDetail[] ?? []);
            setFormVal(formVal)
            setMaintenanceTotal(newMaintenanceTotal)
            setItemTotal(newItemTotal)
        }
    };

    const onCancel = () => {
        setOfferPrint(false)
        setMaintenanceList([]);
        setFormVal({})
        setMaintenanceTotal(initDesc)
        setItemTotal(initDesc)
    }
    const onConfirm = async () => {
        let { id, saleCode } = selectedRow
        await onPrinting({ id, saleCode })
    }
    const columns = [
        {
            title: '序号 No',
            dataIndex: 'No',
        },
        {
            title: '编号 Code',
            dataIndex: 'materialCode',
        },
        {
            title: '名称 Name',
            dataIndex: 'materialName',
        },
        {
            title: '英文名称 NameEn',
            dataIndex: 'materialNameEn',
        },
        // {
        //     title: '规格 Specs',
        //     dataIndex: 'model',
        // },
        // {
        //     title: '产地 Origin',
        //     dataIndex: 'madeFrom',
        // },
        {
            title: '单位 Unit',
            dataIndex: 'unitName',
        },
        {
            title: '数量 Qty',
            dataIndex: 'num',
        },
        // {
        //     title: '单价 Unit price',
        //     dataIndex: 'price',
        // },
        {
            // title: '折后单价 Discounted Price',
            title: '单价 Unit price',
            dataIndex: 'taxPrice',
        },
        {
            title: '金额 Amount',
            dataIndex: 'amount',
        },
        {
            title: '备注 Remark',
            dataIndex: 'note',
        },
    ]
    const itemClumns = [
        {
            title: '序号 No',
            dataIndex: 'No',
        },
        {
            title: '编号 Code',
            dataIndex: 'itemCode',
        },
        {
            title: '名称 Name',
            dataIndex: 'itemName',

        },
        {
            title: '英文名称 NameEn',
            dataIndex: 'itemNameEn',

        },
        // {
        //     title: '规格 Spec 无',
        //     dataIndex: 'num',
        // },
        // {
        //     title: '产地 Origin 无',
        //     dataIndex: 'num',
        // },
        {
            title: '单位 Unit wu',
            dataIndex: 'unitName',
        },
        {
            title: '数量 Num',
            dataIndex: 'workHour',
        },
        {
            title: '单价 Unit price',
            dataIndex: 'price',
        },
        {
            title: '金额 Sum',
            dataIndex: 'amount',
        },
        {
            title: '备注 Note',
            dataIndex: 'note',
        },
    ]
    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: "报价单位 Customer name：",
                fieldValue: formVal?.customerName,
                className: "header-single"
            },
            // {
            //     fieldLabel:"",
            // },
            // {
            //     fieldLabel:"",
            // },
            // {
            //     fieldLabel:"",
            // },                        
            {
                fieldLabel: "报价单号 Quotation：",
                fieldValue: formVal?.saleCode
            },
            {
                fieldLabel: "制单员 Operator：",
                fieldValue: formVal?.createUser
            },
            {
                fieldLabel: "第1/1页",
                fieldValue: ""
            },
            {
                fieldLabel: "合计金额 Total：",
                fieldValue: fmoney(formVal?.receivedAmount,2)
            },
        ],
        footer: [
            {
                fieldLabel: "地址 Address：",
                fieldValue: formVal?.address
            },
            {
                fieldLabel: "电话 Tel：",
                fieldValue: formVal?.phone
            },
            {
                fieldLabel: "结算方式 Payment Type：",
                fieldValue: getTreeNodeName(formVal?.payType as string)
            },
            {
                fieldLabel: "备注 Remark：",
                fieldValue: formVal?.note
            },
        ],

    }
    const headerTitle = {
        titleEn: "Asia-Africa International FZE",
        title: "报价单 Quotation"
    }
    return (
        <YhOfferPrint
            title="报价单打印详情"
            type=""
            visible={visible}
            onClose={onCancel}
            onConfirm={onConfirm}
            columns={columns}
            dataSource={maintenanceList}
            printShow={printShow}
            headerTitle={headerTitle}
        />
    )
}